// React
import React from "react";

// Libs
import { Row, Col } from "react-bootstrap";

// Icons
import premiumProductIcon from "../../../../../assets/premium-products-icon-square.svg";
import removeIcon from "../../../../../assets/remove-icon-square.svg";
import packageIcon from "../../../../../assets/package-icon-square.svg";
import paperMoneyIcon from "../../../../../assets/paper-money-icon-square.svg";
import chatIcon from "../../../../../assets/chat-icon-square.svg";

const StepOne = () => {
  const style = {
    downgradeList: {
      title: {
        fontWeight: "normal",
        lineHeight: "1.57"
      },
      list: {
        display: "flex",
        alignItems: "center",
        marginTop: "20px"
      },
      icon: {
        marginRight: "10px"
      }
    }
  };

  const data = {
    downgradeList: [
      {
        icon: premiumProductIcon,
        alt: "Premium product icon",
        text: (
          <span>
            You cannot push <strong>Premium Products</strong>
          </span>
        )
      },
      {
        icon: removeIcon,
        alt: "Remove icon",
        text: (
          <span>
            Premium products you’ve imported <strong>will be removed</strong>
          </span>
        )
      },
      {
        icon: packageIcon,
        alt: "Package icon",
        text: (
          <span>
            You can only push <strong>25 products</strong>
          </span>
        )
      },
      {
        icon: chatIcon,
        alt: "Chart icon",
        text: (
          <span>
            Your order count will be <strong>limited to 100</strong>
          </span>
        )
      },
      {
        icon: paperMoneyIcon,
        alt: "Paper money icon",
        text: (
          <span>
            You cannot use <strong>Branded Invoices</strong>
          </span>
        )
      },
      {
        icon: chatIcon,
        alt: "Chat icon",
        text: (
          <span>
            You cannot get <strong>chat support</strong>
          </span>
        )
      }
    ]
  };

  return (
    <div>
      <Row>
        <Col md={12} style={style.downgradeList.title}>
          The following changes will be made to your account if you downgrade:
        </Col>
      </Row>
      {data.downgradeList.map((list, index) => (
        <Row style={style.downgradeList.list} key={index}>
          <Col md={1} style={style.downgradeList.icon}>
            <img src={list.icon} alt={list.alt} />
          </Col>
          <Col md={11}>{list.text}</Col>
        </Row>
      ))}
    </div>
  );
};

export default StepOne;



// WEBPACK FOOTER //
// ./src/components/_Shared/Modals/DowngradePlanModal/StepOne/index.js